
/**
 * Represents all of the actions that a user can perform on the calendar.
 */
export class ActionType {

    /**
     * Update the Mini-Calendar to show the next month of dates.
     * 
     * Loads the next month if it's not already loaded.
     */
    static get NextMonth() {
        return "NextMonth";
    }

    /**
     * Update the Mini-Calendar to show the previous month of dates.
     */
    static get PreviousMonth() {
        return "PreviousMonth";
    }

    /**
     * Update the Sticky-Nav's displayed month based on current scroll position.
     */
    static get UpdateScrolledDate() {
        return "UpdateScrolledDate";
    }

    static get SelectedDate() {
        return "SelectedDate";
    }

    /**
     * Set the CurrentDate property in the store
     */
    static get SetDate() {
        return "SetDate";
    }

    static get SetCurrentMonth() {
        return "SetCurrentMonth";
    }

    /**
     * Load more dates (removes the restricted range if one is applied)
     */
    static get LoadMore() {
        return "LoadMore";
    }

    static get SetEventType() {
        return "SetEventType";
    }
    static get GoToMonth() {
        return "GoToMonth";
    }
    /**
     * Updates the selected options for a filter
     */
    static get UpdateEventFilter() {
        return "UpdateEventFilter";
    }

    /**
     * Updates the selected options for a filter
     */
    static get RemoveEventFilter() {
        return "RemoveEventFilter";
    }

    /**
     * Update the Type Filter with new options
     */
    static get SaveTypeFilterOptions() {
        return "SaveTypeFilterOptions";
    }

    /**
     * Update the Genre Filter with new options
     */
    static get SaveGenreFilterOptions() {
        return "SaveGenreFilterOptions";
    }

    /**
     * Update the Partner Filter with new options
     */
    static get SavePartnerFilterOptions() {
        return "SavePartnerFilterOptions";
    }

    /**
     * Update the Accessibility Filter with new options
     */
    static get SaveVenueFilterOptions() {
        return "SaveVenueFilterOptions";
    }

    /**
     * Update the Discount Filter with new options
     */
    static get SaveAvailabilityFilterOptions() {
        return "SaveAvailabilityFilterOptions";
    }

    /**
     * Open the filters modal
     */
    static get OpenFiltersDialog() {
        return "OpenFiltersDialog";
    }

    /**
     * Close the filters modal
     */
    static get CloseFiltersDialog() {
        return "CloseFiltersDialog";
    }

    /**
     * Open the mini-calendar modal (only works on mobile)
     */
    static get OpenMiniCalDialog() {
        return "OpenMiniCalDialog";
    }

    /**
     * Close the mini-calendar modal (called automatically if the screen resizes to larger than mobile)
     */
    static get CloseMiniCalDialog() {
        return "CloseMiniCalDialog";
    }

    /**
     * Reset all filters' `selectedOptions` properties to []
     */
    static get RemoveAllEventFilters() {
        return "RemoveAllEventFilters";
    }

    /**
     * Save additional API events (after `LoadMore` / `NextMonth` are called)
     */
    static get UpdateGridEvents() {
        return "UpdateGridEvents";
    }
    static get UpdateNextMonthEvents() {
        return "UpdateNextMonthEvents";

    }
    static get UpdateEvents() {
        return "UpdateEvents";
    }

    /**
     * Called after `LoadMore` / `NextMonth`, used to check whether additional dates need to be loaded
     */
    static get CheckIfNewMonth() {
        return "CheckIfNewMonth";
    }

    /**
     * Single action to modify the `updating` property based on the new state
     */
    static get CheckIfUpdating() {
        return "CheckIfUpdating";
    }

    /**
     * Updates the calendar settings (NOT CURRENTLY IN USE)
     */
    static get UpdateSettings() {
        return "UpdateSettings";
    }

    /**
     * Update the calendar's text
     */
    static get ReceiveText() {
        return "ReceiveText";
    }

    /**
     * Wait for an image to load, called from the LazyLoad component
     */
    static get WaitForImage() {
        return "WaitForImage";
    }

    /**
     * Mark an image as `loaded` in the store
     */
    static get ImageHasLoaded() {
        return "ImageHasLoaded";
    }

    static get SetToMobile() {
        return "SetToMobile";
    }
    static get SetToDesktop() {
        return "SetToDesktop";
    }
    static get SetToGrid() {
        return "SetToGrid";
    }
    static get SetToList() {
        return "SetToList";
    }
}